export default __webpack_public_path__ + "static/media/0x8a2870fb69a90000d6439b7adfb01d4ba383a415.cc62c9dc.png";